import * as React from 'react';
import { AnalysisIcon } from '../../../web/components/svgs/icons/AnalysisIcon';
import { DiscountIcon } from '../../../web/components/svgs/icons/DiscountIcon';
import { EditItemPenIcon } from '../../../web/components/svgs/icons/EditItemPenIcon';
import { EmailIcon } from '../../../web/components/svgs/icons/EmailIcon';
import { HistoryIcon } from '../../../web/components/svgs/icons/HistoryIcon';
import { LightningBoltIcon } from '../../../web/components/svgs/icons/LightningBoltIcon';
import { ListOfQuestionsIcon } from '../../../web/components/svgs/icons/ListOfQuestionsIcon';
import { LockIcon } from '../../../web/components/svgs/icons/LockIcon';
import { MicIcon } from '../../../web/components/svgs/icons/MicIcon';
import { PhoneIcon } from '../../../web/components/svgs/icons/PhoneIcon';
import { PriorityFlagIcon } from '../../../web/components/svgs/icons/PriorityFlagIcon';
import { ReportsIcon } from '../../../web/components/svgs/icons/ReportsIcon';
import { SparklesIcon } from '../../../web/components/svgs/icons/SparklesIcon';
import { StarIcon } from '../../../web/components/svgs/icons/StarIcon';
import { TagIcon } from '../../../web/components/svgs/icons/TagIcon';
import { TargetGoalsIcon } from '../../../web/components/svgs/icons/TargetGoalsIcon';
import { ToolsIcon } from '../../../web/components/svgs/icons/ToolsIcon';
import { UsersIcon } from '../../../web/components/svgs/icons/UsersIcon';
import { SettingsCardType } from '../../models/setting';
import { TrophyIcon } from '../svgs/icons/TrophyIcon';

// The icon set has no shared color prop, so each renderer passes `currentColor` through whichever prop that icon
// reads and the tile supplies the hue as CSS `color`.
export const SettingIcons: Partial<Record<SettingsCardType, (className: string) => React.ReactNode>> = {
	[SettingsCardType.AgentTemplates]: className => <SparklesIcon className={className} />,
	[SettingsCardType.Blitzes]: className => <LightningBoltIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.CallAnalysis]: className => <AnalysisIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.Categories]: className => <TagIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.DashAndReports]: className => <ReportsIcon className={className} fill='currentColor' />,
	[SettingsCardType.EmailSignature]: className => <EditItemPenIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.EmailTemplates]: className => <EmailIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.Gamification]: className => <TrophyIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.Goals]: className => <TargetGoalsIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.IssuesLog]: className => <PriorityFlagIcon className={className} />,
	[SettingsCardType.ManageUsers]: className => <UsersIcon className={className} />,
	[SettingsCardType.Password]: className => <LockIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.PhoneNumbers]: className => <PhoneIcon className={className} fill='currentColor' />,
	[SettingsCardType.PrizesLog]: className => <HistoryIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.ScenarioManagement]: className => (
		<ListOfQuestionsIcon className={className} fillColor='currentColor' />
	),
	[SettingsCardType.SlotMachinePrizes]: className => <DiscountIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.SlotMachines]: className => <StarIcon className={className} fillColor='currentColor' />,
	[SettingsCardType.Utilities]: className => <ToolsIcon className={className} fill='currentColor' />,
	[SettingsCardType.Voicemail]: className => <MicIcon className={className} />,
};
